export const hash = 'fb84e612-04ee-425b-a7f3-d247e40eda67';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';



//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://15encontroprevidencia.encontrodigital.com.br';
export const urlWebsite = 'https://15encontroprevidencia.encontrodigital.com.br';
export const supportNumber = `5551992141027`;
export const home = 'Home';
export const haveTranslate = false;
export const defaultProjectHash = 'evento';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = '15º Encontro de Previdência Complementar - Região Sul';
export const logo = '/assets/logo2.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = '15º Encontro de Previdência Complementar - Região Sul';
export const dadosOrganizacao = '';
export const social = {
    whatsapp: '',
    instagram: '',
    facebook: '',
    linkedin: '',
    youtube: '',
    spotify: '',
    twitter: '',
};


export const defaultTheme = {
    defaultBackground: '#fff',
    defaultColor: '#333',
    logo: {
        minWidth: '450px',
    },
    menu: {
        background: '#fff',
        backgroundSticky: '#fff',
        backgroundMobile: '#333',
        color: '#333',
        shadow: '0',
        logoColor: 'none',
    },
};

export const getToken = (): string | null => {
    const token = localStorage.getItem(`@${authTitle}:token`);
    return token;
};
